// extracted by mini-css-extract-plugin
export var dayLabel = "_kb-0";
export var pickerDisabled = "_kb-1";